import * as React from 'react';
import { Props } from '..';

const Copy: React.FC<Props> = ({
  color = 'currentColor',
  strokeWidth = 1.5,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={color}
    strokeWidth={strokeWidth}
  >
    <path d="m10 9.5c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5 1.5.672 1.5 1.5zm8.5-6.5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5zm3 5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5zm-13 5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm15.5 5v2c0 2.206-1.794 4-4 4h-4c-2.206 0-4-1.794-4-4v-2c0-1.474.81-2.75 2-3.444v-1.556c0-2.206 1.794-4 4-4s4 1.794 4 4v1.556c1.19.694 2 1.97 2 3.444zm-8-4h4v-1c0-1.103-.897-2-2-2s-2 .897-2 2zm6 4c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2h4c1.103 0 2-.897 2-2zm-4-.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5zm-5.545-14.228c.45 1.588 1.21 3.043 2.26 4.325.35.428.98.49 1.407.14s.49-.98.14-1.407c-.976-1.19-1.654-2.57-2-4.061-.307-1.324-1.482-2.239-2.899-2.24-3.405.141-6.609 1.829-8.742 4.485-1.725 2.158-2.621 4.783-2.621 7.522 0 5.707 3.996 10.567 9.486 11.703.527.115 1.073-.227 1.186-.771.115-.54-.229-1.071-.77-1.187-4.054-.862-7.266-4.318-7.81-8.402-.368-2.764.375-5.47 2.091-7.618 1.762-2.193 4.407-3.602 7.219-3.733.414-.008.816.282.911.692.043.185.09.368.142.551z" />
  </svg>
);

export default Copy;
